<p class="text"><ng-content></ng-content></p>
